import { render, staticRenderFns } from "./DialogPerson.vue?vue&type=template&id=1ca1ca8e&scoped=true&"
import script from "./DialogPerson.vue?vue&type=script&lang=js&"
export * from "./DialogPerson.vue?vue&type=script&lang=js&"
import style0 from "./DialogPerson.vue?vue&type=style&index=0&id=1ca1ca8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca1ca8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VDialog,VDivider,VRow,VSpacer})
